import { getDetailsEventsWeeklyReport } from '../../services/workReport';

export const getDetailsEventsWeeklyReportFunctionAdapter = (requestNumber) =>
  new Promise((resolve, reject) => {
    getDetailsEventsWeeklyReport(requestNumber)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export default getDetailsEventsWeeklyReportFunctionAdapter;
